import { z } from 'zod';

/** Canonical backend/FE region vocabulary, in stable facet-display order. */
export const REGION_VALUES = [
  'africa',
  'latam',
  's_asia',
  'se_asia',
  'global_em',
  'mena',
  'e_europe',
  'asia',
  'europe',
  'na',
  'oceania',
] as const;

export const canonicalRegionSchema = z.enum(REGION_VALUES);
export type Region = z.infer<typeof canonicalRegionSchema>;

export const REGION_LABELS: Readonly<Record<Region, string>> = {
  africa: 'Africa',
  latam: 'Latin America',
  s_asia: 'South Asia',
  se_asia: 'Southeast Asia',
  global_em: 'Global / Multi-region EM',
  mena: 'MENA',
  e_europe: 'E. Europe & C. Asia',
  asia: 'Asia (other)',
  europe: 'Europe',
  na: 'North America',
  oceania: 'Oceania / Australia & New Zealand',
};

/** Region-bearing transport slices used for producer/consumer round-trip locks. */
export const publicRegionFacetSchema = z.object({
  value: canonicalRegionSchema,
  count: z.number().int().nonnegative(),
}).passthrough();

export const adminRegionFacetSchema = publicRegionFacetSchema.extend({
  label: z.string().min(1),
});

export const regionProjectSliceSchema = z.object({
  region: canonicalRegionSchema,
  rawRegion: z.string().nullable().optional(),
}).passthrough();
